import { Link } from "react-router-dom";
import { useStripeMode } from "@/hooks/useStripeMode";

export default function Footer() {
  const stripeMode = useStripeMode();
  return (
    <footer className="border-t border-brand-border/60 bg-brand-bone">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 lg:py-12 grid sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
        <div className="md:col-span-1">
          <Link to="/" className="inline-flex items-center gap-2 mb-3 tap-spring" data-testid="footer-logo-home-link">
            {/* BRAND-01 (2026-07-04) — Primary Logo image includes the "Colour
                Match" wordmark, so no separate text span is needed here. */}
            <img
              src="/branding/primary-logo.png"
              alt="ColourMatch"
              className="h-11 w-auto"
              width="163"
              height="143"
              decoding="async"
            />
          </Link>
          <p className="text-xs text-brand-muted leading-relaxed">
            AI paint colour visualisation. Try any colour, on your own photo, in seconds.
          </p>
        </div>

        <div>
          <div className="text-xs font-semibold text-brand-muted uppercase tracking-widest mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-brand-ink hover:text-brand-teal" data-testid="footer-colourmatch-home">ColourMatch Home</Link></li>
            <li><Link to="/painters/join" className="text-brand-ink hover:text-brand-teal" data-testid="footer-colourmatch-pro">ColourMatch Pro</Link></li>
            <li><Link to="/pricing" className="text-brand-ink hover:text-brand-teal" data-testid="footer-pricing">Pricing overview</Link></li>
            <li><Link to="/contact" className="text-brand-ink hover:text-brand-teal" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold text-brand-muted uppercase tracking-widest mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="text-brand-ink hover:text-brand-teal" data-testid="footer-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="text-brand-ink hover:text-brand-teal" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/refunds" className="text-brand-ink hover:text-brand-teal" data-testid="footer-refunds">Refund Policy</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold text-brand-muted uppercase tracking-widest mb-3">Account</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="text-brand-ink hover:text-brand-teal" data-testid="footer-login">Sign in</Link></li>
            <li><Link to="/register" className="text-brand-ink hover:text-brand-teal" data-testid="footer-register">Create account</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-border/60">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-xs text-brand-muted">
          <p>© {new Date().getFullYear()} ColourMatch. All rights reserved.</p>
          <p data-testid="footer-stripe-mode">
            Made with care in Australia
            {stripeMode.test && " · Currently in Stripe TEST mode"}
          </p>
        </div>
      </div>
    </footer>
  );
}
